import React, { useContext } from 'react'
import { FilterValue } from '../Action/Action';
import { GVarState } from '../StoreState/Gstate';

function SubHeader() {
    let g = useContext(GVarState);
    return (
        <div className='newsubheader'>
            <input type="text" className='changePlaceHolder' value={g.EndSearchInput ? g.EndSearchInput.name : ""}
                placeholder='Look for your most loved brands' onFocus={(e) => FilterValue(e, g, "end")}
                onChange={(e) => { FilterValue(e, g, "end") }} />
            <img src="/images/Search.png" alt="" />
        </div>
    )
}

export default SubHeader